import React, { useEffect, useState } from "react"
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "./selfInspection.module.css"
import axios from "axios"
import moment from "moment"
import { RootDispatch } from "../../app/store"
import { getSettingDetail, selectTenant } from "../user/setting/settingSlice"
import { selectCredentials, selectTenantName } from "../../app/applicationSlice"
import { useLocation } from "react-router-dom"
import { NavBar } from "../../compnents/nav/NavBar"
import { dateFormat } from "../../models/appointment"
import { getSJWHTokenAsync } from "../dataMaintenance/organization/data"
import {
  AXIOS_IP,
  getTeantDetailAsync,
} from "../filingManagement/fileUploadService"
import { printMedicalSelfCheck } from "../../models/selfInspectionPrint"

export const SelefInspectionForm = () => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const credentials: any = useSelector(selectCredentials)

  const [messageApi, contextHolder] = message.useMessage()

  const tenantName = useSelector(selectTenantName)

  const tenant: any = useSelector(selectTenant)

  const [form] = Form.useForm()

  const [token, setToken] = useState("")

  const [detail, setDetail] = useState<any>({})

  const [orgDetail, setOrgDetail] = useState<any>({})

  const [tableData, setTableData] = useState<any>({})

  const [loading, setLoading] = useState(false)

  const [show, setShow] = useState(false)

  const getTableData = (inspectionType: number, token: string) => {
    axios({
      url: `${AXIOS_IP}/selfInspection/data`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "GET",
      params: {
        inspectionType,
      },
    })
      .then((res) => {
        const dataList = res.data.data || []
        const groupedData: any = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
        }
        dataList.forEach((item: any) => {
          const selfDetailType = item?.selfDetailType
          if (
            selfDetailType &&
            Object.prototype.hasOwnProperty.call(groupedData, selfDetailType)
          ) {
            groupedData[selfDetailType].push(item)
          }
        })
        setTableData(groupedData)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getTableType = (type: number) => {
    switch (type) {
      case 1:
        return "（一）许可情况"
      case 2:
        return "（二）人员情况"
      case 3:
        return "（三）执业情况"
      case 4:
        return "（四）传染病管理"
      case 5:
        return "（五）其他"
      default:
        return ""
    }
  }

  const getSelfPeriod = () => {
    const month = moment().month() + 1
    if (month >= 1 && month <= 3) return "年度"
    if (month >= 4 && month <= 6) return "一季度"
    if (month >= 7 && month <= 9) return "二季度"
    if (month >= 10 && month <= 12) return "三季度"
    return "一季度"
  }

  // type区分是否是重新提交
  const getDetail = (type: number, token: string) => {
    axios({
      url: `${AXIOS_IP}/selfInspection/detail`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "GET",
      params: {
        id: location?.state?.id,
      },
    }).then((res) => {
      if (res.data.data) {
        setShow(res.data.data?.selfPeriod == "年度")
        if (type == 1) {
          form.setFieldsValue({
            ...res.data.data,
            selfDate: res.data.data?.selfDate
              ? moment(res.data.data?.selfDate)
              : null,
          })
        } else {
          setDetail({
            ...res.data.data,
            selfDate:
              moment(res.data.data?.selfDate)?.format("YYYY年M月DD日") || "",
          })
        }
        const dataList = res.data.data?.detailList || []
        const groupedData: any = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
        }
        dataList.forEach((item: any) => {
          const selfDetailType = item?.selfDetailType
          if (
            selfDetailType &&
            Object.prototype.hasOwnProperty.call(groupedData, selfDetailType)
          ) {
            groupedData[selfDetailType].push(item)
          }
        })
        setTableData(groupedData)
      }
    })
  }

  useEffect(() => {
    dispatch(getTeantDetailAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setOrgDetail(res)
      })
  }, [])

  useEffect(() => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        if (location?.state?.type == 1) {
          if (location?.state?.selfTYpe == 1) {
            getDetail(1, token)
          } else {
            getTableData(getSelfPeriod() == "年度" ? 2 : 1, token)
          }
        } else {
          getDetail(2, token)
        }
      })
  }, [location?.state?.type])

  useEffect(() => {
    dispatch(getSettingDetail())
  }, [])

  useEffect(() => {
    if (!location?.state?.id) {
      form.setFieldsValue({
        orgName: tenant?.name,
        address: tenant?.address,
        legalRepresentative: tenant?.legalPerson,
        phone: tenant?.phone,
        postalCode: tenant?.postCode,
        selfPeriod: getSelfPeriod(),
      })
      setShow(getSelfPeriod() == "年度")
    }
  }, [tenant])

  return (
    <>
      {contextHolder}
      <NavBar
        where={["自查管理", "自查申请"]}
        backtrace={{
          name: "依法执业自查",
          path: "/selfInspectionLegalPractice",
        }}
        style={{ margin: "10px 20px 0" }}
        buttons={location?.state?.type == 2 ? 
          <Button
            type="primary"
            onClick={() => {
              const content = printMedicalSelfCheck(show, tableData)
              const page: any = window.open("", "_blank") // 打开一个新窗口，用于打印
              page.document.write(content) // 写入打印页面的内容
              page.print() // 打印
              page?.close()
            }}
            size="small"
          >
            打印
          </Button>
        : <></>
        }
      />
      <div
        className={styles.contents}
        style={{
          position: "relative",
          margin: "10px 20px",
          height: "calc(100% - 80px)",
          display: "flex", 
          flexDirection: "column",
          overflow: "hidden", 
        }}
      >
        <div style={{ 
    flex: 1,
    overflowY: "auto",
    padding: 30,
    paddingBottom: 10 
  }}>
          <Form
            form={form}
            initialValues={{
              year: moment().year(),
              selfDate: moment(),
            }}
            style={{ paddingBottom: 30 }}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            onFinish={(values) => {
              const flatData = Object.values(tableData)
                .flat()
                .map((item: any) =>
                  // 未勾选"合理缺项"的行，hasItem 统一为 1（相当于原来的"有"）
                  item.hasItem === undefined ? { ...item, hasItem: 1 } : item,
                )
              const invalidItems: any[] = flatData.filter(
                (item: any) =>
                  item.hasItem !== 0 &&
                  (item.isOk === undefined || item.isOk === null),
              )
              if (invalidItems.length > 0) {
                messageApi.open({
                  type: 'warning',
                  content: '每行检查项请勾选"合理缺项"或在"是/否"中选择一项',
                  className: 'custom-class',
                  style: {
                    marginTop: '35vh',
                  },
                })
                const firstInvalidItem = invalidItems[0]
                const situation = Object.keys(tableData).find((key) => 
                  tableData[key as unknown as number].some((item: any) => item.id === firstInvalidItem.id)
                )
                if (situation) {
                  const situationNum = parseInt(situation)
                  const rowIndex = tableData[situationNum].findIndex((item: any) => item.id === firstInvalidItem.id)
                  if (rowIndex !== -1) {
                    const tableElement = document.getElementById(`table-${situationNum}`)
                    if (tableElement) {
                      const rows = tableElement.querySelectorAll('.ant-table-row')
                      const targetRow = rows[rowIndex]
                      if (targetRow) {
                        targetRow.scrollIntoView({ behavior: 'smooth', block: 'center' })
                      }
                    }
                  }
                }
                return
              }
              setLoading(true)
              axios({
                url: `${AXIOS_IP}/selfInspection/add`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": token,
                },
                withCredentials: false,
                method: "POST",
                data: {
                  ...values,
                  id: location?.state?.id,
                  applicantUserId: credentials.userId,
                  applicantUserName: credentials.userName,
                  selfType: values?.selfPeriod == "年度" ? 1 : 0,
                  orgCode: orgDetail?.tenant?.nationUniqueCode,
                  selfDate: moment(values.selfDate).format("YYYY-MM-DD"),
                  detailList: flatData,
                  memo: location?.state?.memo,
                },
              })
                .then(() => {
                  notification.success({
                    message: "操作成功",
                    duration: 3,
                  })
                  history.go(-1)
                })
                .finally(() => {
                  setLoading(false)
                })
            }}
            scrollToFirstError={{ 
              behavior: 'smooth', 
              block: 'center', 
            }}
          >
            <Row>
              <Col span={8}>
                <Form.Item
                  name="year"
                  label="自查年份"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input allowClear addonAfter="年" />
                  ) : (
                    detail?.year
                  )}
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item
                  name="selfPeriod"
                  label="自查周期"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Radio.Group
                      onChange={(e) => {
                        setShow(e.target.value == "年度" ? true : false)
                        getTableData(e.target.value == "年度" ? 2 : 1, token)
                      }}
                    >
                      <Radio value={"一季度"}>一季度</Radio>
                      <Radio value={"二季度"}>二季度</Radio>
                      <Radio value={"三季度"}>三季度</Radio>
                      <Radio value={"年度"}>年度</Radio>
                    </Radio.Group>
                  ) : (
                    detail?.selfPeriod
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.title}>一、基本情况</Row>
            <Row>
              <Col span={16}>
                <Form.Item
                  name="orgName"
                  label="机构名称"
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input allowClear />
                  ) : (
                    detail?.orgName
                  )}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="orgRepresentative"
                  label="机构负责人"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input allowClear />
                  ) : (
                    detail?.orgRepresentative
                  )}
                </Form.Item>
              </Col>
              {show && (
                <Col span={16}>
                  <Form.Item
                    name="address"
                    label="单位地址"
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                    rules={[{ required: true }]}
                  >
                    {location?.state?.type === 1 ? (
                      <Input allowClear />
                    ) : (
                      detail?.address
                    )}
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item
                  name="legalRepresentative"
                  label="法定代表人"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input allowClear />
                  ) : (
                    detail?.legalRepresentative
                  )}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="principal"
                  label="主要负责人"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input allowClear />
                  ) : (
                    detail?.principal
                  )}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="phone"
                  label="联系电话"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input allowClear />
                  ) : (
                    detail?.phone
                  )}
                </Form.Item>
              </Col>
              {show && (
                <Col span={8}>
                  <Form.Item
                    name="postalCode"
                    label="邮政编码"
                    rules={[{ required: true }]}
                  >
                    {location?.state?.type === 1 ? (
                      <Input allowClear />
                    ) : (
                      detail?.postalCode
                    )}
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item
                  name="practicingPhysiciansNumber"
                  label="执业医师"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input
                      allowClear
                      addonAfter="人"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "")
                        form.setFieldsValue({ practicingPhysiciansNumber: value })
                      }}
                    />
                  ) : detail?.practicingPhysiciansNumber + "人"}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="practicingAssistantPhysiciansNumber"
                  label="执业助理医师"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input
                      allowClear
                      addonAfter="人"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "")
                        form.setFieldsValue({
                          practicingAssistantPhysiciansNumber: value,
                        })
                      }}
                    />
                  ) : detail?.practicingAssistantPhysiciansNumber + "人"}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="nurseNumber"
                  label="护士"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input
                      allowClear
                      addonAfter="人"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "")
                        form.setFieldsValue({ nurseNumber: value })
                      }}
                    />
                  ) : detail?.nurseNumber + "人"}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="drugNumber"
                  label="药剂人员"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input
                      allowClear
                      addonAfter="人"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "")
                        form.setFieldsValue({ drugNumber: value })
                      }}
                    />
                  ) : detail?.drugNumber + "人"}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="medicalTechnologyNumber"
                  label="医技检验人员"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <Input
                      allowClear
                      addonAfter="人"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "")
                        form.setFieldsValue({ medicalTechnologyNumber: value })
                      }}
                    />
                  ) : detail?.medicalTechnologyNumber + "人"}
                </Form.Item>
              </Col>
              {show && (
                <Col span={8}>
                  <Form.Item
                    name="approveBedNumber"
                    label="标准床位数"
                    rules={[{ required: true }]}
                  >
                    {location?.state?.type === 1 ? (
                      <Input allowClear />
                    ) : detail?.approveBedNumber + "张"}
                  </Form.Item>
                </Col>
              )}
              {show && (
                <Col span={8}>
                  <Form.Item
                    name="actualBedNumber"
                    label="实际开设床位数"
                    rules={[{ required: true }]}
                  >
                    {location?.state?.type === 1 ? (
                      <Input allowClear />
                    ) : detail?.actualBedNumber + "张"}
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item
                  name="selfDate"
                  label="自查日期"
                  rules={[{ required: true }]}
                >
                  {location?.state?.type === 1 ? (
                    <DatePicker allowClear={false} style={{ width: '100%' }} format={dateFormat} />
                  ) : (
                    detail?.selfDate
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.title} justify="space-between">
              <Col span={12}>二、检查内容:</Col>
              {location?.state?.type === 1 ? (
                <Col
                  span={12}
                  style={{
                    color: "rgba(255,160,55,1)",
                    fontSize: 14,
                    fontWeight: "normal",
                    textAlign: "right",
                  }}
                >
                  注：年度全面自查应于每年1月的第一个工作周内进行并提交；没有该项目的，填“无”。
                </Col>
              ) : (
                ""
              )}
            </Row>
            <Row style={{ paddingLeft: 30 }}>
              <Col span={24}>
                {[1, 2, 3, 4, 5].map((situation) => (
                  <div key={situation} id={`table-${situation}`} style={{ marginBottom: 20 }}>
                    <Table
                      dataSource={tableData[situation] || []}
                      columns={[
                        {
                          title: (
                            <span style={{ fontWeight: "bold" }}>
                              {getTableType(situation)}
                            </span>
                          ),
                          align: "left",
                          dataIndex: "title",
                          key: "title",
                          render: function Element(_, t, index) {
                            const count1 = (tableData[1] || []).length
                            const count2 = (tableData[2] || [])?.length
                            const count3 = (tableData[3] || [])?.length
                            const count4 = (tableData[4] || [])?.length
                            const startIndex =
                              (situation === 1
                                ? 0
                                : situation === 2 ? count1 
                                : situation === 3 ? count1 + count2
                                : situation === 4 ? count1 + count2 + count3
                                : situation === 4 ? count1 + count2 + count3 + count4
                                : count1 + count2 + count3 + count4) + index
                            return (
                              <span>
                                {startIndex + 1}.{t.title}
                              </span>
                            )
                          },
                        },
                        {
                          title: (
                            <span style={{ fontWeight: "bold" }}>合理缺项</span>
                          ),
                          align: "center",
                          dataIndex: "hasItem",
                          key: "hasItem",
                          width: "160px",
                          render: function Element(_, t) {
                            return (
                              <Checkbox
                                checked={t.hasItem === 0}
                                disabled={location?.state?.type !== 1}
                                onChange={(e) => {
                                  setTableData({
                                    ...tableData,
                                    [situation]: tableData[situation].map(
                                      (item: any) => {
                                        if (item.id === t.id) {
                                          return {
                                            ...item,
                                            // 勾选合理缺项相当于原来的“无”，未勾选相当于“有”
                                            hasItem: e.target.checked ? 0 : 1,
                                            // 勾选合理缺项后“是/否”禁选，isOk 传 null
                                            isOk: e.target.checked
                                              ? null
                                              : undefined,
                                          }
                                        }
                                        return item
                                      },
                                    ),
                                  })
                                }}
                              >
                                合理缺项
                              </Checkbox>
                            )
                          },
                        },
                        {
                          title: (
                            <span style={{ fontWeight: "bold" }}>是/否</span>
                          ),
                          align: "center",
                          dataIndex: "isOk",
                          key: "isOk",
                          width: "160px",
                          render: function Element(_, t) {
                            return location?.state?.type === 1 ? (
                              <Radio.Group
                                value={t.isOk}
                                disabled={t.hasItem === 0}
                                onChange={(e) => {
                                  setTableData({
                                    ...tableData,
                                    [situation]: tableData[situation].map(
                                      (item: any) => {
                                        if (item.id === t.id) {
                                          return {
                                            ...item,
                                            isOk: e.target.value,
                                            // 选择"是/否"说明该项不是合理缺项，hasItem 对应原来的"有"
                                            hasItem: 1,
                                          }
                                        }
                                        return item
                                      },
                                    ),
                                  })
                                }}
                              >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                              </Radio.Group>
                            ) : t.isOk === 1 ? "是" : t.isOk === 0 ? "否" : ""
                          },
                        },
                      ]}
                      pagination={false}
                    />
                  </div>
                ))}
              </Col>
            </Row>
          </Form>
        </div>
        {location?.state?.type === 1 && (
              <Row justify="center" style={{ background: '#fff', padding: '15px', textAlign: 'center' }}>
                <Space>
                  <Button onClick={() => history.go(-1)}>取消</Button>
                  <Button type="primary" loading={loading} onClick={() => {
                    Modal.confirm({
                      title: "确认提交吗？",
                      okText: "确认",
                      onOk: () => {
                        form.submit()
                      },
                    })
                  }}>
                    提交
                  </Button>
                </Space>
              </Row>
            )}
      </div>
    </>
  )
}
